import * as React from "react";

import { Funding, Modernizations, ServiceItem } from "../../calcBusterTypes";
import { Tabs } from "@amzn/awsui-components-react";
import ArrTab from "./arr-tab/ArrTab";
import EligibleServicesTab from "./eligible-services-tab/EligibleServicesTab";

const MAPSection: React.FC<{
  funding: Funding;
  modernizations: Modernizations;
  services: ServiceItem[];
}> = ({ funding, modernizations, services }) => {
  return (
    <Tabs
      tabs={[
        {
          label: "Annual Run Rate",
          id: "arr_tab",
          content: <ArrTab funding={funding} />,
        },
        {
          label: "Eligible Services",
          id: "eligible_services_tab",
          content: (
            <EligibleServicesTab funding={funding} services={services} />
          ),
        },
      ]}
    />
  );
};

export default MAPSection;
